<section class="app2 services">
  <div class="container">
    <div class="row">
      @defer(on idle){
      <div class="col-md-10 offset-md-1">
        <div class="sub-title mb-3">
          <h2 class="title-text text-center">{{title}}</h2>
        </div>
        <div class="title title2">
          <img [src]="serviceImage" alt="" class="img-fluid title-img">
          <p class="font-secondary borders main-text"><span>{{mainText}}</span></p>
        </div>
      </div>
      @for (service of serviceContainer; track $index) {
      <div class="col-lg-4 col-md-6 service-container">
        <div class="service text-center">
          @if (service.imgService.data) {
          <div class="img-block">
            <img [src]="service.imgService.data.attributes.url" alt="" class="service-img img-fluid mb-3">
          </div>
          }
          <div class="service-feature d-flex flex-column align-items-center">
            <p class="feature-text text-center mb-5 ">{{service.title}}</p>
            <p class="text-center mb-3 w-75">{{service.description}}</p>
          </div>
        </div>
      </div>
      }
      }@placeholder {
      @switch (screenSize$ | async) {
      @case ('xsmall') {
      <div class="col-sm-6 counters">
        <div class="abouts center-text">
          <div>
            <div class="list-about">
              <p class="mb-2 mt-3">
                <ngx-skeleton-loader count="2" [theme]="{width:'20.6875em'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 counters set-height d-flex justify-content-center me-5">
        <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
      </div>
      }@case ('small') {
      <div class="d-flex justify-content-center gap-5">
        <div class="col-sm-4 counters set-height d-flex justify-content-center me-5">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
        <div class="col-sm-4 counters set-height d-flex justify-content-center ">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
      </div>
      }@case ('medium') {
      <div class="d-flex justify-content-center">
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
      </div>
      }@default {
      <div class="d-flex justify-content-center">
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
        <div class="col-sm-4 counters set-height d-flex justify-content-center">
          <ngx-skeleton-loader [theme]="{height:'22.125em', width:'18.8875em'}" />
        </div>
      </div>
      }
      }
      }
    </div>
  </div>
</section>
